import { Card, Typography, Space, Row, Col, Statistic } from "antd";
import { ShoppingCartOutlined } from "@ant-design/icons";

const { Text } = Typography;

export const WebsiteOrdersSection: React.FC = () => {
  return (
    <Card className="rounded-2xl border-gray-100 shadow-sm overflow-hidden transition-all duration-300 hover:shadow-md">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
        <Space size="middle">
          <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-blue-50 text-blue-500">
            <ShoppingCartOutlined className="text-lg" />
          </div>
          <div>
            <Text strong className="text-gray-800 text-base block">
              Website Orders
            </Text>
            <Text type="secondary" className="text-xs">
              Storefront order flow & transactional status
            </Text>
          </div>
        </Space>
      </div>

      <Row gutter={[16, 16]} className="mb-6">
        <Col xs={12} sm={6}>
          <Card
            size="small"
            className="bg-blue-50/40 border-blue-100/60 rounded-xl"
          >
            <Statistic
              title={
                <Text className="text-xs text-gray-500 font-medium">
                  Total Orders
                </Text>
              }
              value={124}
              valueStyle={{ fontSize: 20, fontWeight: 700, color: "#2563eb" }}
            />
          </Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card
            size="small"
            className="bg-green-50/40 border-green-100/60 rounded-xl"
          >
            <Statistic
              title={
                <Text className="text-xs text-gray-500 font-medium">
                  Total Sales
                </Text>
              }
              value={49200}
              precision={2}
              suffix="LKR"
              valueStyle={{ fontSize: 20, fontWeight: 700, color: "#16a34a" }}
            />
          </Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card
            size="small"
            className="bg-amber-50/40 border-amber-100/60 rounded-xl"
          >
            <Statistic
              title={
                <Text className="text-xs text-gray-500 font-medium">
                  Pending Orders
                </Text>
              }
              value={3}
              valueStyle={{ fontSize: 20, fontWeight: 700, color: "#d97706" }}
            />
          </Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card
            size="small"
            className="bg-indigo-50/40 border-indigo-100/60 rounded-xl"
          >
            <Statistic
              title={
                <Text className="text-xs text-gray-500 font-medium">
                  Conversion Rate
                </Text>
              }
              value={2.8}
              suffix="%"
              valueStyle={{ fontSize: 20, fontWeight: 700, color: "#4f46e5" }}
            />
          </Card>
        </Col>
      </Row>
    </Card>
  );
};
